"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  name: "Astrid",
  role: "EMP Chair Kundin",
  text: "Seit ich den EMP Chair regelmäßig nutze, hat sich mein Körpergefühl komplett verändert. Ich fühle mich viel straffer und mein Selbstbewusstsein ist deutlich gestiegen.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_astrid.png",
  rating: 5
}, {
  id: 2,
  name: "Franziska",
  role: "Begeisterte Anwenderin",
  text: "Die Atmosphäre bei Linda ist einfach wunderbar. Man fühlt sich sofort gut aufgehoben. Die Ergebnisse der Behandlungen sprechen für sich – ich bin absolut überzeugt!",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_franziska.png",
  rating: 5
}, {
  id: 3,
  name: "Anja",
  role: "Stammkundin",
  text: "Ich schätze die professionelle Beratung und die herzliche Art. Hier wird wirklich auf die individuellen Bedürfnisse eingegangen. Mein Hautbild hat sich massiv verbessert.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_anja.png",
  rating: 5
}, {
  id: 4,
  name: "Nora",
  role: "Wellness-Liebhaberin",
  text: "Ein Ort der Ruhe und Entspannung. Die Kombination aus modernster Technik und Lindas Expertise ist einzigartig. Ich freue mich jedes Mal auf meinen Termin.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_nora.png",
  rating: 5
}, {
  id: 5,
  name: "Christina I.",
  role: "Körperbewusst",
  text: "Die Behandlungen sind effektiv und entspannend zugleich. Ich habe schon viele Studios ausprobiert, aber hier stimmt einfach das Gesamtpaket aus Qualität und Wohlbefinden.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_christina.png",
  rating: 5
}, {
  id: 6,
  name: "Beatrix S.",
  role: "Zufriedene Kundin",
  text: "Dank der gezielten Anwendungen fühle ich mich in meinem Körper wieder richtig wohl. Die Beratung war ehrlich und kompetent. Absolut empfehlenswert!",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_beatrix.png",
  rating: 5
}, {
  id: 7,
  name: "Martina F.",
  role: "Gesundheitsorientiert",
  text: "Man merkt sofort, dass Linda ihr Handwerk versteht. Die Räumlichkeiten sind wunderschön und die Ergebnisse der Lymphdrainage waren sofort spürbar.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_martina.png",
  rating: 5
}, {
  id: 8,
  name: "Regina M.",
  role: "Langzeitkundin",
  text: "Ich bin seit Jahren Kundin und immer wieder begeistert von den Innovationen, die Linda anbietet. Es ist meine kleine Auszeit vom Alltag mit echtem Mehrwert.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/testimonial_regina.png",
  rating: 5
}];
export default function CustomerTestimonials() {
  return <section data-section-id="240358" id="testimonials" className="relative bg-background text-foreground py-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/interior_design_texture.png)] bg-cover bg-center" />
        <div className="absolute inset-0 bg-background/90 !bg-[url(https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-123-scaled.jpg)]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default font-bold tracking-tight text-secondary !text-6xl">Das sagen unsere Anwender</h2>
          <div className="mx-auto mt-4 h-1 w-20 bg-accent rounded-lg" />
        </div>

        <div className="mx-auto w-full max-w-6xl">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                  <div className="h-full p-1">
                    <Card className="h-full bg-card backdrop-blur-sm border-border shadow-lg transition-all duration-[400ms] ease-out hover:shadow-xl hover:-translate-y-1">
                      <CardContent className="flex h-full flex-col justify-between p-8">
                        <div>
                          <div className="mb-4 flex gap-1">
                            {[...Array(testimonial.rating)].map((_, index) => <Star key={index} className="size-4 fill-accent text-accent" />)}
                          </div>
                          <Quote className="mb-6 size-10 text-accent/60" />
                          <p className="text-[20px] italic leading-relaxed text-foreground/80 !font-sans">
                            "{testimonial.text}"
                          </p>
                        </div>

                        <div className="mt-8 flex items-center gap-4 border-t border-border pt-6">
                          <SafeHydrate><Avatar className="size-16 border-2 border-accent shadow-sm">
                            <AvatarImage src={testimonial.avatar} alt={testimonial.name} className="object-cover" />
                            <AvatarFallback className="bg-muted text-muted-foreground">
                              {testimonial.name.charAt(0)}
                            </AvatarFallback>
                          </Avatar></SafeHydrate>
                          <div>
                            <h3 className="font-default text-lg font-semibold text-primary">
                              {testimonial.name}
                            </h3>
                            <p className="text-sm text-muted-foreground">
                              {testimonial.role}
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            <div className="mt-12 flex items-center justify-center gap-4">
              <CarouselPrevious className="static translate-x-0 translate-y-0 bg-accent/20 border-accent/30 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
              <CarouselNext className="static translate-x-0 translate-y-0 bg-accent/20 border-accent/30 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}